import styled from 'styled-components';

export const Container = styled.div`
  width: min(92vw, 500px);
  background: #fffefc;
  border-radius: 1rem;
  overflow: hidden;

  .primary-button {
    height: 2.8rem;
    font-size: 0.9rem;
    padding: 0 1.2rem;
    border-radius: 0.55rem;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    box-shadow: 0px 3px 8px rgba(255, 0, 0, 0.3);
  }

  .secondary-button {
    height: 2.8rem;
    font-size: 0.9rem;
    padding: 0 1.2rem;
    border-radius: 0.55rem;
    border: 1.5px solid #1e88e5;
    color: #1e88e5;
    display: flex;
    align-items: center;
    gap: 0.4rem;

    &:hover {
      color: #4caf50;
      border: 1px solid #4caf50;
      svg {
        transition: transform 0.3s;
        stroke: #4caf50;
      }
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e3e2e2;
`;

export const Title = styled.h3`
  font-family: 'RedHatDisplay-Bold';
  font-size: 1.15rem;
  color: #323232;
  margin: 0;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 0.5rem;
  background: transparent;
  color: #323232;
  cursor: pointer;
  transition:
    background 0.2s,
    color 0.2s;

  &:hover {
    background: #f2f2f2;
    color: #1e88e5;
  }
`;

export const Body = styled.div`
  padding: 1.5rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Description = styled.p`
  color: #4b5563;
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0;
`;

export const Actions = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
`;
